module.exports = __webpack_public_path__ + "static/img/slogan.6e36d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan.png
// module id = OwT5
// module chunks = 2